import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { AuditEntryDto } from '@thebb/shared';
import { get } from '../api';
import { PageTitle, Spinner, fmtTime } from '../components/ui';

export function AuditPage() {
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const data = useQuery({
    queryKey: ['audit', q, page],
    queryFn: () => get<{ items: AuditEntryDto[]; total: number; perPage: number }>(`/audit?page=${page}&perPage=50&q=${encodeURIComponent(q)}`),
  });
  const pages = data.data ? Math.max(1, Math.ceil(data.data.total / data.data.perPage)) : 1;
  return (
    <div>
      <PageTitle title="Log" actions={<input className="input w-64" placeholder="Søg" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} />} />
      {data.isLoading ? (
        <Spinner />
      ) : (
        <>
          <table className="table card p-0">
            <thead>
              <tr>
                <th>Tid</th>
                <th>Hvem</th>
                <th>Handling</th>
                <th>Hvad</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {data.data?.items.map((e) => (
                <tr key={e.id}>
                  <td className="whitespace-nowrap">{fmtTime(e.at)}</td>
                  <td>{e.actorName}</td>
                  <td className="font-mono text-xs">{e.action}</td>
                  <td>
                    {e.summary}
                    {(e.before != null || e.after != null) && (
                      <details className="text-xs text-zinc-500">
                        <summary>detaljer</summary>
                        <pre className="max-w-xl overflow-auto whitespace-pre-wrap">{JSON.stringify({ before: e.before, after: e.after }, null, 1)}</pre>
                      </details>
                    )}
                  </td>
                  <td className="text-xs text-zinc-500">{e.ip ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-3 flex items-center gap-2 text-sm">
            <button className="btn" disabled={page <= 1} onClick={() => setPage(page - 1)}>
              Forrige
            </button>
            <span>
              Side {page} af {pages}
            </span>
            <button className="btn" disabled={page >= pages} onClick={() => setPage(page + 1)}>
              Næste
            </button>
          </div>
        </>
      )}
    </div>
  );
}
